import React from 'react'
import { useLocale } from '../contexts/LocaleContext'
import StoreBadges from './StoreBadges'

/** The volunteer app for iPhone and Android, with the check-in screen as proof. */
const MobileApps: React.FC = () => {
  const { locale, t } = useLocale()
  const points = t('apps.points') as string[]

  return (
    <section
      id="app"
      className="mx-auto grid max-w-[1280px] items-center gap-12 px-5 py-16 sm:px-8 lg:grid-cols-2 lg:gap-16 lg:px-14 lg:py-[88px]"
    >
      <div>
        <span className="inline-flex items-center rounded-pill bg-clay-100 px-3 py-1 text-[13px] font-semibold text-clay-700">
          {t('apps.eyebrow')}
        </span>
        <h2 className="mt-4 text-balance font-display text-[30px] font-bold tracking-display sm:text-[38px]">
          {t('apps.title')}
        </h2>
        <p className="mt-4 max-w-[48ch] text-[17px] leading-relaxed text-text-secondary">
          {t('apps.body')}
        </p>

        <ul className="mt-6 flex flex-col gap-2.5 text-[15px] text-text-primary">
          {points.map((point) => (
            <li key={point} className="flex gap-2.5">
              <span aria-hidden className="font-bold text-status-success">
                ✓
              </span>
              {point}
            </li>
          ))}
        </ul>

        <StoreBadges className="mt-8" />
        <p className="mt-3.5 text-[13px] text-text-muted">{t('apps.note')}</p>
      </div>

      <div className="mx-auto w-[260px] rounded-[44px] bg-neutral-900 p-2.5 shadow-raised sm:w-[280px]">
        <img
          src={`/img/app-check-in-${locale}.jpg`}
          alt={t('apps.screenshotAlt')}
          width={600}
          height={1303}
          loading="lazy"
          className="block h-auto w-full rounded-[36px]"
        />
      </div>
    </section>
  )
}

export default MobileApps
